import React from 'react';
import { Row, Col } from 'react-bootstrap';
import {
  marketShare,
  totalOrder,
  weeklySalesData,
  weather
} from 'data/dashboard/default';

import axios from 'helpers/api';
import { useEffect } from 'react'
import WeeklySales from './WeeklySales';
import TotalOrder from './TotalOrder';
import MarketShare from './MarketShare';
import Weather from './Weather';
import CycleStatus from './CycleStatus';
import OrderData from '../OrderData';
import PrescriptionStatusShimmer from '../PrescriptionStatusShimmer';
import { ACCESS_CONTROL } from '../../authentication/accessControlMap'
import CaregiverDashboard from '../../sharedliving-caregiver/CaregiverDashboard'
import { isCaregiverRole } from 'helpers/isSharedLivingActive'

const Dashboard = () => {
const [facilityFlag, setFacilityFlag] = React.useState(false);
const [orderDetails, setOrderDetails] = React.useState([]);
const [orderLoader, setOrderLoader] = React.useState(false);
let localStorageAccessControl = localStorage.getItem("accessControl");
const dayprogramActive = localStorageAccessControl.includes(ACCESS_CONTROL["dayprogramactive"])

  const setHoldReasonsData = async () => {
    if (Number(localStorage.getItem("roleId")) >= 4) {
      return;
    }

    let tokenStr = localStorage.getItem("accessToken");
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/drugs/list-hold-reasons/`, {
        headers: { 'Authorization': `Bearer ${tokenStr}` }
      });

      if (data.hold_reasons.status) {
        const holdReasonsData = data.hold_reasons.data || [];
        const activeHoldReasonsData = holdReasonsData
          .filter(reason => Number(reason.is_active) === 1)
          .map(reason => ({
            key: reason.reason,
            value: reason.id
          }));

        localStorage.setItem("holdReasonsData", JSON.stringify(holdReasonsData));
        localStorage.setItem("activeHoldReasonsData", JSON.stringify(activeHoldReasonsData));
      }
    } catch (error) {
      console.log("Error in setHoldReasonsData " + error);
    }
  };

  useEffect(() => {

    async function setInitialData() {

      //console.log("Setting Initial Data");

      let tokenStr = localStorage.getItem("accessToken");
      let drugResults = [];
      let groupId = localStorage.getItem("groupId") ? localStorage.getItem("groupId") : "";

      // SharedLiving caregivers (role 7) have no facilities of their own, but
      // their assigned patients live at real facilities. Derive
      // facilitiesData / groupsData from /athome/my-patients so downstream
      // consumers (PatientDetails, AddEditPatient.populatePatientData, etc.)
      // find the same shape they expect for other roles.
      if (Number(localStorage.getItem("roleId")) === 7) {
        try {
          const { data } = await axios.get(
            `${process.env.REACT_APP_SERVER_URL}/athome/my-patients?include_historical=true`,
            { headers: { Authorization: `Bearer ${tokenStr}` } }
          );
          const list = data?.patients?.data || data?.data || data?.patients || [];

          const facilityMap = new Map();
          const groupMap = new Map();
          (Array.isArray(list) ? list : []).forEach((p) => {
            if (p.facility_id && !facilityMap.has(p.facility_id)) {
              facilityMap.set(p.facility_id, {
                key: p.facility_name || `Facility ${p.facility_id}`,
                value: p.facility_id,
                group_id: p.group_id,
                external_facility_id: p.external_facility_id
              });
            }
            if (p.group_id && !groupMap.has(p.group_id)) {
              groupMap.set(p.group_id, {
                key: p.group_name || `Group ${p.group_id}`,
                value: p.group_id
              });
            }
          });

          const facilityResults = Array.from(facilityMap.values()).sort((a, b) =>
            a.key.localeCompare(b.key)
          );
          const groupResults = Array.from(groupMap.values()).sort((a, b) =>
            a.key.localeCompare(b.key)
          );

          localStorage.setItem("facilitiesData", JSON.stringify(facilityResults));
          localStorage.setItem("groupsData", JSON.stringify(groupResults));
          setFacilityFlag(true);
        } catch (err) {
          // Never block the caregiver's dashboard on this cache build —
          // worst case the caches stay empty and the consumers that need
          // them gracefully show "no data".
          localStorage.setItem("facilitiesData", JSON.stringify([]));
          localStorage.setItem("groupsData", JSON.stringify([]));
        }
      }
      //set group details
      else if (localStorage.getItem("roleId") < 4) {

        //prepopulate group data
        await axios.get(`${process.env.REACT_APP_SERVER_URL}/facilities/get-all-facility`, { headers: { 'Authorization': `Bearer ${tokenStr}` } })
          .then((res) => {

            //console.log("res.data " + JSON.stringify(res.data.data));

            let objGrpData = res.data.data;
            let facilityResults = [];
            let groupResults = [];

            for (let index in objGrpData) {

              let grpData = objGrpData[index];
              let facilities = grpData.facilities;

              groupResults.push({
                key : grpData.name,
                value : grpData.id,
                // Carry per-group feature flags so admin forms can gate UI
                // by the SELECTED group's permissions, not the logged-in
                // user's own group. Mapping (backend /facilities/get-all-facility):
                //   4 = is_dayprogram_active, 5 = is_sharedliving_active.
                access_control : grpData.access_control || []
              })

              facilities.forEach((value) => {
                facilityResults.push({
                  key: value.facility_name,
                  value: value.id,
                  group_id : value.group_id,
                  external_facility_id : value.external_facility_id
                });
              });

              //console.log("GrpData " + JSON.stringify(grpData));
            };

            // sort group data by key
            facilityResults.sort((a, b) => a.key.localeCompare(b.key));
            groupResults.sort((a, b) => a.key.localeCompare(b.key));
            localStorage.setItem("facilitiesData", JSON.stringify(facilityResults));
            localStorage.setItem("groupsData", JSON.stringify(groupResults));

          });
      }
      else {
        //prepopulate facility data for a group id
        let results = [];

        const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/facilities/list-facility/" + groupId, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        //console.log("Facilties Data Set Data " + JSON.stringify(data.data) + groupId);

        let objData = data.data;

        objData.forEach((value) => {
          //groupId = value.group_id;
          results.push({
            key: value.facility_name,
            value: value.id,
            group_id: value.group_id,
            external_facility_id: value.external_facility_id
          });
        });

        // sort facility data by key
        results.sort((a, b) => a.key.localeCompare(b.key));

        //console.log("Facilities Data ", objData);
        //localStorage.setItem("groupId", groupId);

        localStorage.setItem("facilitiesData", JSON.stringify(results));
        setFacilityFlag(true);


      }

      //prepopulate drugs data
      // await axios.get(`${process.env.REACT_APP_SERVER_URL}/drugs/list-drugs/`, { headers: { 'Authorization': `Bearer ${tokenStr}` } })
      //   .then((res) => {

      //     let objDrugData = res.data.drugs.data;

      //     //localStorage.setItem("ogdrugData", JSON.stringify(objDrugData));

      //     objDrugData.forEach((value) => {
      //       let drugBrand = value.brand_drug != null ? value.brand_drug : "";
      //       let drugNdc = value.ndc != null ? value.ndc : "";
      //       let drugForm = value.drug_form != null ? value.drug_form : "";
      //       let drugGeneric = value.generic != null ? value.generic : "";

      //       drugResults.push({
      //         key: value.drug,
      //         value: value.id + "|" + value.drug + "|" + drugBrand + "|" + drugNdc + "|" + drugForm + "|" + drugGeneric,
      //       });
      //     });

      //     //console.log("DrugResults " + drugResults);
      //     //localStorage.setItem("drugData", JSON.stringify(drugResults)); NEED TO OPTIMIZE FURTHER

      //   });

    }
    
    setInitialData();
    if(Number(localStorage.getItem('roleId')) === 4 && dayprogramActive){
      fetchDayPrograms()
    } else if(Number(localStorage.getItem("roleId")) > 4 && Number(localStorage.getItem("roleId")) < 7 && dayprogramActive){
      fetchDayProgramsForUsers()
    }
    if(Number(localStorage.getItem("roleId")) > 3 && Number(localStorage.getItem("roleId")) < 6){
      GetOrderDetails();
    }
    setHoldReasonsData();
  }, []);

  const fetchDayPrograms = async () => {
    try {
      const tokenStr = localStorage.getItem('accessToken');
      const { data } = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/day-programs/list`,
        { headers: { Authorization: `Bearer ${tokenStr}` } }
      );
      const results = [];
      results.push(...data.data.filter(dayProgram => Number(dayProgram.is_active) === 1).map(dayProgram => ({
        key: dayProgram.name,
        value: dayProgram.id
      })));
      localStorage.setItem('dayProgramOptions', JSON.stringify(results));
    } catch (error) {
      navigate('/error');
    }
  };

  const fetchDayProgramsForUsers = async () => {
    try {
      const tokenStr = localStorage.getItem('accessToken');
      const { data } = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/day-programs/my-programs`,
        { headers: { Authorization: `Bearer ${tokenStr}` } }
      );
      const results = [];
      results.push(...data.data.filter(dayProgram => Number(dayProgram.is_active) === 1).map(dayProgram => ({
        key: dayProgram.name,
        value: dayProgram.id
      })));
      localStorage.setItem('dayProgramOptions', JSON.stringify(results));

    } catch (error) {
      navigate('/error');
    }
  };

  const GetOrderDetails = async () => {
    setOrderLoader(true);
    let tokenStr = localStorage.getItem("accessToken");
    let pelmedsMedSheetUrl = `${process.env.REACT_APP_SERVER_URL}` + "/dashboard/";
    try{
      let {data} = await axios.get(
        pelmedsMedSheetUrl,
        { headers: { 'Authorization': `Bearer ${tokenStr}` } }
      );
      setOrderDetails(data.data.facilityStats);
    }catch(error){
      console.log("Error in GetOrderDetails " + error);
    }finally{
      setOrderLoader(false);
    }
  }

  if (isCaregiverRole()) {
    return <CaregiverDashboard />;
  }

  return (
    <>
      {(Number(localStorage.getItem("roleId")) > 3 && Number(localStorage.getItem("roleId")) < 6) ? <Row className="g-3 mb-3">
        <Col xs={12} xxl={6} className="d-flex">
          <div className="w-100 h-100">
            <CycleStatus facilityFlag = {facilityFlag} />
          </div>
        </Col>
        <Col xs={12} xxl={6}>
          <Row className="g-2 h-100">
            <Col xs={12} md={6}>
              <WeeklySales data={weeklySalesData} />
            </Col>
            <Col xs={12} md={6}>
              <TotalOrder data={totalOrder} />
            </Col>
            <Col xs={12} md={6}>
              <MarketShare data={marketShare} radius={['100%', '87%']} />
            </Col>
            <Col xs={12} md={6}>
              {orderLoader ? <PrescriptionStatusShimmer /> : <OrderData data={orderDetails} />}
            </Col>
          </Row>
        </Col>
      </Row> : <Row className="g-3 mb-3">
        <Col md={6} xxl={3}>
          <WeeklySales data={weeklySalesData} />
        </Col>
        <Col md={6} xxl={3}>
          <TotalOrder data={totalOrder} />
        </Col>
        <Col md={6} xxl={3}>
          <MarketShare data={marketShare} radius={['100%', '87%']} />
        </Col>
        <Col md={6} xxl={3}>
          <Weather data={weather} />
        </Col>
      </Row>}

      {/*<Row className="g-3 mb-3">
        <Col lg={6}>
          <RunningProjects data={runningProjects} />
        </Col>
        <Col lg={6}>
          <TotalSales data={totalSales} />
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col lg={6} xl={7} xxl={8}>
          <StorageStatus className="h-lg-100" data={storageStatus} />
        </Col>
        <Col lg={6} xl={5} xxl={4}>
          <SpaceWarning />
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col lg={7} xl={8}>
          <BestSellingProducts products={products} />
        </Col>
        <Col lg={5} xl={4}>
          <SharedFiles files={files} className="h-lg-100" />
        </Col>
      </Row>

      <Row className="g-3">
        <Col sm={6} xxl={3}>
          <ActiveUsers className="h-100" users={users} />
        </Col>
        <Col sm={6} xxl={3} className="order-xxl-1">
          <BandwidthSaved />
        </Col>
        <Col xxl={6}>
          <TopProducts data={topProducts} className="h-100" />
        </Col>
      </Row>*/}
    </>
  );
};

export default Dashboard;

